import React, { useRef, useState } from "react";
// import "./TemplatComman.css";
import "./Theme71.css";
import Banner from "./../../../../Images/minimarketbg.png"
import LocationIcon from "./../../../../Images/locIcon.png";
import HomeComponent from "./HomeComponent";
import ContactInfo from "./ContactInfo";
import CameraImg from "./../../../../Images/realestate-property1.jpg";
import SinkImg from "./../../../../Images/realestate-property2.jpg";
import HeadphnImg from "./../../../../Images/headphonecollection.png";
import tempLogo from '../../../../Images/constructionlogo.jpg'
import ShoesImg from "./../../../../Images/shoescollection.png";


        


const Theme71Template = (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const calendarInputRef = useRef(null);
  const [activeTab, setActiveTab] = useState("home");


 


  const renderContent = () => {
    switch (activeTab) {
      case "home":
        return <div> <HomeComponent /> </div>;
      case "aboutus":
        return <div className="flex text-justify font-Tajawal text-[#101010] font-base text-lg">
          {/* Brown uses drawing as a prerequisite to guide her work. Through the use of repetition, Brown captures images that both attract and confound her.  Though her drawings are not as exhibited as her paintings, both art mediums contain similar aspects in showcasing her erotic view of art through subject matter.  */}
        </div>;
      case "contactinfo":
        return <div> </div>;
      default:
        return null;
    }
  };
 
  return (
    <div>
      <style>
      {`
        #temp71 .miniMenuActive {
          color: ${'#ff6933'};
          border-bottom: 2px solid ${'#ff6933'} !important;
          margin-bottom: -2px;
          font-weight:600
        }

        #temp71 .miniMenuInactive {
          color: ${"#6b7280" };
          margin-bottom: -2px;

        }

        #temp71 .miniMenuInactive:hover {
          color: ${'#ff6933'};
          border-bottom: 2px solid ${props?.dynamicCtaColor} !important;
        }
      `}
    </style>
      <div class="main-temaplt" id="temp71">
        <div className="container">
          <div className="row justify-content-center">
            <div style={{ width: "420px" }} className="col-12 wtemplate p-4">
              <div class="propertyUpper"></div>
             <div>
              <div className="propertyMinimktheader">
                  

                    <div className="userData">

                    <img src={tempLogo} className="avatar" />
                    <div className="propertyUser">
                      <h3>Mathew Adam</h3>
                      <h6>Senior Real Estate Consultant</h6>
                      <p>Adam's Luxury Real Estate</p>
                    </div>

                  </div>

                </div>

              <div className="p-0  mx-0 mb-3 flex justify-between items-center  " style={{ color: `${'#CCCCCC'}` ,borderBottom: `1px solid ${"#ccc"}` }}>
                  <div>
                    <div 
                    style={{ width: "65px"}} className={` mt-3 pb-1 px-2  text-lg cursor-pointer text-center hover:font-bold  hover:transition all ${activeTab === "home"
                          ? `miniMenuActive`
                          : 'miniMenuInactive'
                          }`}
                    onClick={() => setActiveTab("home")}>Portfolio</div>
                  </div>

                  <div>
                    <div  style={{ width: "90px"}} className={`mt-3 pb-1  text-lg cursor-pointer text-center hover:font-bold hover:text-coffee hover:transition all ${activeTab === "aboutus"
                        ? `miniMenuActive`
                          : 'miniMenuInactive'
                        }`}
                     onClick={() => setActiveTab("aboutus")}>About us</div>
                  </div>

                  <div>
                    <div tyle={{ width: "110px"}} className={`mt-3 pb-1 text-lg text-center cursor-pointer hover:font-bold hover:text-coffee hover:transition all ${activeTab === "contactinfo"
                          ? `miniMenuActive`
                          : 'miniMenuInactive'
                          }`}
                     onClick={() => setActiveTab("contactinfo")}>Contact Info</div>
                  </div>
                
              </div>

              <div className="px-2 py-2">{renderContent()}</div>

              <div>
                    <button
                        className="bg-coffee border-none px-4 py-1 text-base rounded-full text-white"
                        // onClick={() => setActiveTabb("All")}
                        style={{ margin: '0 10px', backgroundColor:'#ff6933' }}
                    >
                        All
                    </button>
                    <button
                        className="px-4 py-1 rounded-full text-base  text-b45"
                        // onClick={() => setActiveTabb("All")}
                        style={{ margin: '0 10px', backgroundColor:'#f3f4f6' }}
                    >
                        Apartment
                    </button>
                    <button
                        className="px-4 py-1 rounded-full text-base  text-b45"
                        // onClick={() => setActiveTabb("All")}
                        style={{ margin: '0 10px', backgroundColor:'#f3f4f6'}}
                    >
                        Farmhouse
                    </button>
                 
                </div>
              <div className='py-4 px-0 grid grid-cols-1 gap-2'>
        <div className='miniExtCard'>
          <div className='imgPriceWrapper'>
            <img loading="lazy" src={CameraImg} className='object-cover prodimg' />
             <p className='productPrice'
                style={{
                margin: "0",
                fontSize: "16px",
                fontFamily: "Inter",
                }}
            >
              ₹5000  
            </p>
            <div className='ready' style={{background : "#16a34a"}}>Ready to move</div>
            </div>
            <div className="text-start font-normal text-base px-2 pt-1 font-Inter minimarketname">The Laurel's Villa</div>
            <div className='propertyAddress' style={{padding:"0 10px"}}>Umm Al Quwain, Dubai</div>
            <div className="flex justify-between items-center mt-1 px-1 pb-2">
                {/* <div className="text-lg font-bold text-black text-sm">$ 120.00</div> */}
                
                <button className={`text-sm font-regular`} style={{borderRadius:"50px", backgroundColor: "#ff6933",color:'#fff',padding:"6px 20px", overflow:"hidden"
                            }}>
                  Interested
                </button>
            </div>
        </div>
       <div className='miniExtCard'>
          <div className='imgPriceWrapper'>
            <img loading="lazy" src={SinkImg} className='object-cover prodimg' />
             <p className='productPrice'
                style={{
                margin: "0",
                fontSize: "16px",
                fontFamily: "Inter",
                }}
            >
              ₹3000  
            </p>
            <div className='ready' style={{background : "#ff6933"}}>Under Construction</div>
            </div>
            <div className="text-start font-normal text-base px-2 pt-1 font-Inter minimarketname">Wings Tower</div>
            <div className='propertyAddress' style={{padding:"0 10px"}}>Al Safa, Dubai</div>
            <div className="flex justify-between items-center mt-1 px-1 pb-2">
                {/* <div className="text-lg font-bold text-black text-sm">$ 120.00</div> */}
                
                <button className={`text-sm font-regular`} style={{borderRadius:"50px", backgroundColor: "#ff6933",color:'#fff',padding:"6px 20px", overflow:"hidden"
                            }}>
                  Interested
                </button>
            </div>
        </div>
</div>

             </div>
              {/* <div className=' bg-white px-2 py-4 sticky spacing -bottom-25 w-full text-center'>
                  <button className='bg-coffee text-xl rounded text-white w-full font-bold font-Tajawal pt-3  p-2'>
                    Contact supplier
                  </button>
                </div> */}
            </div>
            </div>
          </div>
        </div>
      </div>
  
  );
};

export default Theme71Template;
